<div class="breadcrumbGlobal">
  <a [routerLink]="['/mydashboard']">
      <mat-icon>home</mat-icon>
  </a>
  <mat-icon>chevron_right</mat-icon>
  <a [routerLink]="['/vertical-solutions']">
    <span translate>COMMONS.VERTICAL_SOLUTIONS_SECTION</span>
  </a>
  <mat-icon>chevron_right</mat-icon>
  <span translate>COMMONS.VERTICAL_SOLUTIONS_MANAGEMENT</span>
</div>

<tb-header specificTitle="COMMONS.VERTICAL_SOLUTIONS_MANAGEMENT"></tb-header>
<div class="contentGlobal">
  <ms-vertical-solutions-list></ms-vertical-solutions-list>
</div>

